module.exports = __webpack_public_path__ + "assets/icon-money-back.4e785dd0.svg";